import { useState } from 'react';
import { InputFileButton } from 'atoms/InputFileButton';
import { MessageSendButton } from 'atoms/MessageSendButton';
import { TextareaAutosize } from 'atoms/TextareaAutosize';
import { postMessage } from 'hooks/u011/usePostMessageHooks';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';

const MAX_FILE_SIZE = 500 * 1024 * 1024;

type Props = {
  userId: string;
  auditionId: string;
  loading: (isLoading: boolean) => void;
  catchError: (err: string) => void;
  onMessageSent?: () => void;
};

export const CreateMessageArea = (props: Props) => {
  const [message, setMessage] = useState<string>('');
  const [file, setFile] = useState<File | null>(null);
  const { t: tMessage } = useTranslationWithLang('message');
  const { t: tCommons } = useTranslationWithLang('commons');

  const onChangeMessage = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setMessage(event.target.value);
  };

  const onChangeFile = (file: File) => {
    if (file && file.size > MAX_FILE_SIZE) {
      props.catchError(tCommons('TU000_080'));
      setFile(null);
    } else {
      props.catchError('');
      setFile(file);
    }
  };

  const onClickSend = (event: React.MouseEvent<HTMLElement>) => {
    if (message.length <= 0 && !file) return;
    props.loading(true);
    event.preventDefault();
    postMessage(props.userId, props.auditionId, message, file ?? undefined)
      .then((res) => {
        if (res.status === '99') {
          console.error(res.msg);
          props.catchError(tMessage('MU011F0061E'));
        } else {
          setMessage('');
          setFile(null);
          if (props.onMessageSent) {
            props.onMessageSent();
          }
        }
      })
      .catch((err) => {
        console.error(err);
        props.catchError(tMessage('MU011F00061E'));
      })
      .finally(() => {
        props.loading(false);
      });
  };

  return (
    <>
      <div>
        <TextareaAutosize onChange={onChangeMessage} value={message}></TextareaAutosize>
      </div>
      <div className="flex items-center">
        <div className="flex-1 flex items-center overflow-hidden">
          <InputFileButton
            onChange={onChangeFile}
            value={file}
            aria-label={tCommons('TU000_076')}
          ></InputFileButton>
        </div>
        <div className="flex-none text-right">
          <MessageSendButton
            onClick={onClickSend}
            aria-label={tCommons('TU000_077')}
          ></MessageSendButton>
        </div>
      </div>
    </>
  );
};
